import slice from 'store/features/aiAvatar/slice'
import { uploadThunks } from 'store/features/aiAvatar/thunks/upload'
import { voiceThunks } from 'store/features/aiAvatar/thunks/voice'
import { publicAvatarsThunks } from 'store/features/aiAvatar/thunks/publicAvatars'
import { avatarModelsThunks } from 'store/features/aiAvatar/thunks/avatarModels'
import { generateThunks } from 'store/features/aiAvatar/thunks/generate'
import { formThunks } from 'store/features/aiAvatar/thunks/form'
import { giftAccessThunks } from 'store/features/aiAvatar/thunks/giftAccess'

const { actions } = slice

export const aiAvatarThunks = {
  ...actions,
  ...uploadThunks,
  ...voiceThunks,
  ...publicAvatarsThunks,
  ...avatarModelsThunks,
  ...generateThunks,
  ...formThunks,
  ...giftAccessThunks
}
